export default __webpack_public_path__ + "static/trackthebat3-74084ca68d38337ccda6e499df3f05ff.png";